module.exports = __webpack_public_path__ + "img/quan.b8b05c8c.png";